import { useField } from 'formik';
import { nanoid } from 'nanoid';
import React from 'react';

export default function CustomField({
  title,
  placeholder,
  ...attrs
}: {
  title: string;
  placeholder: string;
} & Record<string, any>) {
  const [field] = useField(attrs.name);
  const id = nanoid();
  return (
    <div className="w-full text-[#53586C]">
      <label htmlFor={id} className="font-medium">
        {title}
      </label>
      {attrs.children ? (
        attrs.children
      ) : (
        <input
          id={id}
          className="h-10 w-full border border-[#53586C] rounded py-3 px-4 placeholder:text-gray-700/70 mt-3 disabled:bg-gray-100"
          placeholder={placeholder}
          {...field}
          {...attrs}
        />
      )}
    </div>
  );
}
